import * as tslib_1 from "tslib";
import { PipeTransform } from '@angular/core';
import { TITLE_SUFFIX } from '../translate.suffix';
var TitleTranslatePipe = /** @class */ (function () {
    function TitleTranslatePipe(translateService) {
        this.translateService = translateService;
    }
    TitleTranslatePipe.prototype.transform = function (query, args) {
        var _a;
        if (args === void 0) { args = []; }
        return (_a = this.translateService).transform.apply(_a, tslib_1.__spread([this.translateService.containsRegisteredTranslateSuffix(query) ? query : query + TITLE_SUFFIX], args));
    };
    return TitleTranslatePipe;
}());
export { TitleTranslatePipe };
